module.exports = __webpack_public_path__ + "static/media/inspiration.03eac769.svg";